"use client";

import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/Foundation.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/Foundation.json';

export default createIconSet(glyphMap, 'foundation', font);
